import {datetime} from "@atttomyx/shared-utils";

export const isApproved = (timeOff) => {
    return timeOff.approvedBy !== undefined && timeOff.approvedBy !== null;
};

export const getDefaultDate = (date) => {
    return !date || datetime.isPastDate(date) ? datetime.today() : date;
};
